import classNames from "classnames/bind";
import { TextButtonProps, ButtonShapes } from "../../interface";
import classes from "./textButton.module.scss";

const TextButton = ({
    label,
    variant = "filled",
    disabled = false,
    shape = ButtonShapes.TextButtonRounded,
    onClick,
    ariaPressed,
}: TextButtonProps) => {
    const cx = classNames.bind(classes);
    const textButtonRoundedClasses = cx("textButton", "textButtonRounded", [
        variant,
    ]);
    const textButtonRectClasses = cx("textButton", "textButtonRectangle", [
        variant,
    ]);

    const textButtonClasses =
        shape === ButtonShapes.TextButtonRounded
            ? textButtonRoundedClasses
            : textButtonRectClasses;
    return (
        <button
            type="button"
            className={textButtonClasses}
            disabled={disabled}
            onClick={onClick}
            data-testid="text-button"
            data-cy="button"
            aria-pressed={ariaPressed}
        >
            <span>{label}</span>
        </button>
    );
};

export default TextButton;
